import { render, staticRenderFns } from "./ClassLessonFollowUp.vue?vue&type=template&id=0a96e46f&scoped=true"
import script from "./ClassLessonFollowUp.vue?vue&type=script&lang=js"
export * from "./ClassLessonFollowUp.vue?vue&type=script&lang=js"
import style0 from "./ClassLessonFollowUp.vue?vue&type=style&index=0&id=0a96e46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96e46f",
  null
  
)

export default component.exports